import type { ReactNode } from "react";
import { PageHeader } from "@volca/ui/components/ui/page-components";

export const AccessHeader = ({ actions }: { actions?: ReactNode }) => (
  <PageHeader
    actions={actions}
    title="Workbook access"
    description="Edit a shared draft, review the changes, then apply them to workbook access."
  />
);
